var initialState = {
    byId: []
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.amenity) {
        state = {
            ...state,
            byId: {
                ...state.byId,
                ...action.payload.entities.amenity
            }
        }
    }
    switch (action.type) {
        default:
            return state;
    }
};